export interface GraphPerformanceSample {
  nodeCount: number
  edgeCount: number
  coldLoadMs: number
  interactionP95Ms?: number
  viewport?: 'desktop' | 'mobile'
}

export interface SigmaGateResult {
  shouldReviewSigma: boolean
  reasons: string[]
}

export function evaluateSigmaMigrationGate(sample: GraphPerformanceSample): SigmaGateResult {
  const reasons: string[] = []

  if (sample.nodeCount > 2000) reasons.push('node-count')
  if (sample.edgeCount > 5000) reasons.push('edge-count')
  const loadLimitMs = sample.viewport === 'mobile' ? 6000 : 3000
  if (sample.coldLoadMs > loadLimitMs) {
    reasons.push(sample.viewport === 'mobile' ? 'mobile-load' : 'desktop-load')
  }
  if (sample.interactionP95Ms !== undefined && sample.interactionP95Ms > 50) {
    reasons.push('interaction-latency')
  }

  return {
    shouldReviewSigma: reasons.length > 0,
    reasons,
  }
}
